import { Loader2 } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface LoadingDialogProps {
  open: boolean
  title?: string
}

export default function LoadingDialog({
  open,
  title = 'กำลังโหลด..',
}: LoadingDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="flex flex-col items-center gap-4 py-8"
        aria-describedby=""
        showCloseButton={false}
      >
        {title && (
          <DialogHeader className="w-full items-center">
            <DialogTitle className="text-lg text-center w-full">
              {title}
            </DialogTitle>
          </DialogHeader>
        )}
        <Loader2 className="size-10 animate-spin text-primary" />
      </DialogContent>
    </Dialog>
  )
}
